<template>
  <nav>
    <div v-if="surveyOverview">
      <v-row no-gutters class="text-left">
        <v-col cols="12" class="d-inline-flex mb-3">
          <p class="text-subtitle-1 no-break font-weight-bold" v-html="question.question"></p>
        </v-col>
        <v-col cols="12" class="mb-3" v-if="question.description && strip(question.description).trim() != ''">
          <p
            class="text-subtitle-2 font-weight-regular greytext--text no-break"
            v-html="question.description"
          ></p>
        </v-col>
      </v-row>
      <v-list :style="`background-color:` + question.bg_color">
        <v-row>
          <v-col
            cols="12"
            sm="6"
            lg="4"
            v-for="answer in question.options"
            :key="answer.aid"
          >
            <v-card class="pa-3 fill-height survey-answer-card replace-box-shadow">
              <div
                class="survey-answer-image-editor"
                style="position: relative; overflow: hidden"
              >
                <img
                  v-if="answer.imageDisplay != null"
                  :src="answer.imageDisplay"
                  :path="answer.image"
                  class="custom-image large"
                  crossorigin="*"
                />
                <img
                  v-else
                  src="/assets/editor_images/surveyimageanswer.jpg"
                  class="custom-image large"
                  crossorigin="*"
                />
                <!-- Percentage display -->
                <div
                  v-if="
                    question.stats &&
                    question.stats.hasOwnProperty(answer.aid) &&
                    question.stats[answer.aid]
                  "
                  class="position-relative"
                >
                  <span
                    style="
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      font-size: 24px;
                      font-weight: bold;
                      color: dark;
                      background-color: white;
                      padding: 8px 16px;
                      border-radius: 5px;
                    "
                  >
                    {{
                      calculatePercentage(
                        question.stats[answer.aid],
                        numbSubmissions
                      )
                    }}%
                  </span>
                </div>
                <div v-else class="position-relative">
                  <span
                    style="
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      font-size: 24px;
                      font-weight: bold;
                      color: dark;
                      background-color: white;
                      padding: 8px 16px;
                      border-radius: 5px;
                    "
                  >
                    0%
                  </span>
                </div>
              </div>
              <v-list-item class="pa-0">
                <v-textarea
                  readonly
                  disabled
                  auto-grow
                  dense
                  outlined
                  rows="1"
                  v-model="answer.option"
                  class="survey-answer survey-answer-image rounded-lg pa-0 ma-0 mt-3 text-body-2 replace-box-shadow"
                  :hide-details="false"
                >
                  <template v-slot:prepend-inner>
                    <v-icon class="icon-des mt-n1" color="greytext"
                      >mdi-checkbox-blank-outline</v-icon
                    >
                  </template>
                </v-textarea>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
      </v-list>
    </div>
    <div v-else-if="user">
      <v-row no-gutters class="text-left">
        <v-col cols="12" class="d-inline-flex mb-3">
          <p
            class="text-subtitle-1 no-break font-weight-bold"
            v-html="question.question"
          ></p>
        </v-col>
        <v-col cols="12" class="mb-3" v-if="question.description && strip(question.description).trim() != ''">
          <p
            class="text-subtitle-2 font-weight-regular greytext--text no-break"
            v-html="question.description"
          ></p>
        </v-col>
      </v-row>
      <v-list :style="`background-color:` + question.bg_color">
        <v-row>
          <v-col
            cols="12"
            sm="6"
            lg="4"
            v-for="answer in question.options"
            :key="answer.aid"
          >
            <v-card
              :class="
                user[question.qid].answer.includes(answer.aid)
                  ? 'pa-3 fill-height survey-answer-card survey-answer-individual-image '
                  : 'pa-3 fill-height survey-answer-card'
              "
            >
              <div
                class="survey-answer-image-editor"
                style="position: relative; overflow: hidden"
              >
                <img
                  v-if="answer.imageDisplay != null"
                  :src="answer.imageDisplay"
                  :path="answer.image"
                  class="custom-image large"
                  crossorigin="*"
                />
                <img
                  v-else
                  src="/assets/editor_images/surveyimageanswer.jpg"
                  class="custom-image large"
                  crossorigin="*"
                />
              </div>
              <v-list-item class="pa-0">
                <v-textarea
                  readonly
                  disabled
                  auto-grow
                  dense
                  outlined
                  rows="1"
                  v-model="answer.option"
                  class="survey-answer survey-answer-image rounded-lg pa-0 ma-0 mt-3 text-body-2"
                  :hide-details="false"
                >
                  <template v-slot:prepend-inner>
                    <v-icon
                      class="icon-des mt-n1"
                      v-if="user[question.qid].answer.includes(answer.aid)"
                      color="accent"
                    >
                      mdi-checkbox-outline
                    </v-icon>
                    <v-icon v-else class="icon-des mt-n1" color="greytext">
                      mdi-checkbox-blank-outline
                    </v-icon>
                  </template>
                </v-textarea>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
      </v-list>
    </div>
    <draggable
      v-else
      :list="question.options"
      class="list-group row"
      ghost-class="ghost-block-answer"
      :force-fallback="true"
      :disabled="published"
      handle=".handle"
    >
      <v-col
        cols="12"
        md="6"
        lg="4"
        v-for="(answer, answerIndex) in question.options"
        :key="answer.aid"
      >
        <v-hover>
          <template v-slot:default="{ hover }">
            <v-card
              class="pa-3 fill-height survey-answer-card"
              :class="`elevation-${hover ? 8 : 2} ${
                hover ? 'v-card--shadow' : 'v-card--flat'
              }`"
            >
              <v-card-actions class="pa-0 pb-3 handle">
                <v-icon>mdi-drag-vertical</v-icon>
                <v-spacer />
                <v-icon
                  v-if="hover && question.options.length > 2 && !published"
                  @click="deleteAnswer(question, answerIndex)"
                  >mdi-delete-circle</v-icon
                >
              </v-card-actions>

              <editor-survey
                ref="editImage"
                class="survey-answer-image-editor"
                data-testid="image-editor"
                :content="
                  answer.imageDisplay != null
                    ? `<img src=&quot;` +
                      answer.imageDisplay +
                      `&quot; path=&quot;` +
                      answer.image +
                      `&quot;>`
                    : `<img src=&quot;/assets/editor_images/surveyimageanswer.jpg&quot;>`
                "
                :index="index"
                :answerIndex="answerIndex"
                type="answer"
                part="image"
                @proceedClick="setEditor"
                @updateSurvey="updateSurveyImage"
                @proceedMark="showHideEditorTextOptions"
                @enableEditMode="enableEditMode"
                @showErrorMessage="showErrorMessageImage"
              />

              <div
                v-visible="answer.errorImage && answer.imageDisplay == null"
                class="error--text text-caption text-left"
              >
                {{ $t("imageErrorRequired") }}
              </div>

              <v-textarea
                auto-grow
                dense
                outlined
                rows="1"
                v-model="answer.option"
                class="survey-answer survey-answer-image rounded-lg pa-0 ma-0 mt-3 text-body-2"
                :hide-details="false"
                :placeholder="$t('surveyTextChoicePlaceholder')"
                :rules="inputRules"
                @click="resetEditor()"
                @blur="showErrorMessageImage(index, answerIndex, 'answer')"
              >
                <template v-slot:prepend>
                  <v-icon @click="resetEditor()"
                    >mdi-checkbox-blank-outline</v-icon
                  >
                </template>
              </v-textarea>
            </v-card>
          </template>
        </v-hover>
      </v-col>
    </draggable>
  </nav>
</template>

<script>
import draggable from "vuedraggable";
import {
  ruleRequired,
  answerRuleValid,
} from "../../../rules/formRules.js";
import EditorSurvey from "../../EditorSurvey";
import { repeatedMethodsMixin } from "../../../mixins/repeatedMethodsMixin";

export default {
  props: {
    question: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
    published: {
      type: Boolean,
      default: false,
    },
    surveyOverview: {
      type: Boolean,
      default: false,
    },
    numbSubmissions: {
      type: Number,
      default: 0,
    },
    user: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    draggable,
    EditorSurvey,
  },
  mixins: [repeatedMethodsMixin],
  data() {
    return {
      focusNext(e) {
        const inputs = Array.from(
          e.form.querySelectorAll('input[type="text"]')
        );
        const index = inputs.indexOf(e);
        if (index < inputs.length && inputs[index + 1]) {
          inputs[index + 1].focus();
        }
      },
      inputRules: ruleRequired('labelAnswer').concat(answerRuleValid)
    };
  },
  created() {},

  methods: {
    deleteAnswer(question, answerIndex) {
      this.resetEditor();
      this.$emit("deleteAnswer", question, answerIndex);
    },
    resetEditor() {
      this.$emit("resetEditor");
    },
    setEditor(editor) {
      this.$emit("setEditor", editor);
    },
    updateSurveyImage(type, index, answerIndex, content) {
      this.$emit("updateSurveyImage", type, index, answerIndex, content);
    },
    showHideEditorTextOptions(val) {
      this.$emit("showHideEditorTextOptions", val);
    },
    enableEditMode() {
      this.$emit("enableEditMode");
    },
    showErrorMessageImage(index, answerIndex, type) {
      this.$emit("showErrorMessageImage", index, answerIndex, type);
    }
  },
};
</script>
<style>
.survey-answer-individual-image {
  border: 1px solid blue !important;
  margin-bottom: 0px;
}
</style>
